import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.less';
import { MainLayout } from './layouts/main/MainLayout';


export default function App() {

  React.useEffect(() => {
    document.title = "Mi Negocio";    
  }, []);

  return (
    <BrowserRouter>
      <MainLayout/>
    </BrowserRouter >
  );
}